export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_05-b18b05b74c66f51b6417f8ec83414b9e.jpg";